import faqToggle from './common/_faq-toggle';

addEventListener('DOMContentLoaded', () => {
    // スムーススクロール
    $('a[href^="#"]').click(function(){
        var adjust = 0;
        var speed = 400;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top + adjust;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });

    $('.p-outline__more button').on('click', function () {
        $('.p-outline__hide').slideToggle();
        $(this).toggleClass('is-open');
    });

    faqToggle();
});
